import kochel from "../images/immobilien/kochel.jpg";
import grundKochelGross from "../images/immobilien/grundKochelGross.jpeg";
import architektenVilla from "../images/immobilien/architektenVilla.jpg";
import wackersberg2 from "../images/immobilien/wackersberg2.webp";
import wohnung from "../images/immobilien/wohnung.jpg";
import grundKochelKlein from "../images/immobilien/grundKochelKlein.jpeg";
import laax from "../images/immobilien/laax.webp";
import grundKochelZusammen from "../images/immobilien/grundKochelZusammen.jpeg";
import benediktbeuern from "../images/immobilien/benediktbeuern.webp";
import penzberg from "../images/immobilien/penzberg.jpg";
import kaffeemuehlenVilla from "../images/immobilien/kaffehausvilla.jpg";



const properties = [
    {
    id: "10",

    title: "Architektenvilla in Penzberg",
    shortTitle: "Einfamilienhaus in Penzberg",

    location: "82377 Penzberg",
    price: "849.000 €",

    heroImage: penzberg,

    gallery: [penzberg],

    facts: [
        { label: "Kaufpreis", value: "849.000 €" },
        { label: "Zimmer", value: "5" },
        { label: "Wohnfläche", value: "180 m²" },
        { label: "Grundstück", value: "390 m²" },
        { label: "Adresse", value: "82377 Penzberg" }
    ],

    details: [
        { label: "Objektart", value: "Einfamilienhaus (freistehend)" },
        { label: "Etagen", value: "3" },
        { label: "Wohnfläche", value: "180 m²" },
        { label: "Nutzfläche", value: "140 m²" },
        { label: "Grundstück", value: "390 m²" },
        { label: "Zimmer", value: "5" },
        { label: "Schlafzimmer", value: "3" },
        { label: "Badezimmer", value: "5" },
        { label: "Stellplätze", value: "2 Garagen" },
        { label: "Baujahr", value: "Bestandsgebäude mit modernem Anbau" },
        { label: "Zustand", value: "Erstbezug nach Sanierung / Rohbau" },
        { label: "Heizung", value: "Zentralheizung" },
        { label: "Energieträger", value: "Gas" }
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Zum Verkauf steht ein massiver, komplett erstellter Rohbau mit Keller, bestehend aus einer Bestandsimmobilie, die durch einen modernen Anbau erweitert wurde.",

                "Das Dach wurde vollständig erneuert und die Elektro- sowie Sanitärinstallationen sind bereits fachgerecht vorbereitet. Dadurch kann der individuelle Innenausbau sofort beginnen und nach den eigenen Vorstellungen umgesetzt werden.",

                "Große Fensterfronten und Glas-Schiebetüren sorgen für ein modernes, lichtdurchflutetes Wohngefühl. Die durchdachte Raumaufteilung eignet sich hervorragend für Familien und bietet mit den beiden Gauben im Obergeschoss zusätzlichen Wohnkomfort.",

                "Dieses Objekt bietet die seltene Möglichkeit, eine hochwertige Architektenvilla nach den eigenen Wünschen fertigzustellen und gleichzeitig durch Eigenleistung erhebliche Kosten zu sparen."
            ]
        },

        {
            title: "Ausstattung",
            list: [
                "Komplett erstellter Rohbau mit Keller",
                "Bestandsgebäude mit modernem Anbau",
                "Neues Dach",
                "Elektro- und Sanitärinstallationen vorbereitet",
                "Große Fensterfronten und Glas-Schiebetüren vorgesehen",
                "Praktische und familienfreundliche Raumaufteilung",
                "Lichtdurchflutete Gauben im Obergeschoss",
                "Offener Bereich als Spielzimmer oder 4. Schlafzimmer nutzbar",
                "Private Lounge im Außenbereich möglich",
                "2 Garagen mit je einem Stellplatz davor",
                "Auch als Zweifamilienhaus aufteilbar",
                "Keine versteckten Mängel – ideal für individuellen Innenausbau"
            ]
        },

        {
            title: "Lage",
            paragraphs: [
                "Die Immobilie befindet sich in Penzberg im oberbayerischen Landkreis Weilheim-Schongau.",

                "Die ruhige Wohnlage verbindet naturnahes Wohnen mit einer guten Infrastruktur. Einkaufsmöglichkeiten, Schulen, Kindergärten sowie medizinische Versorgung sind schnell erreichbar.",

                "Durch die Nähe zu den bayerischen Alpen und zahlreichen Seen bietet die Umgebung einen hohen Freizeitwert mit vielfältigen Möglichkeiten zum Wandern, Radfahren und Erholen.",

                "Auch München und Garmisch-Partenkirchen sind dank der guten Verkehrsanbindung bequem erreichbar."
            ]
        },

        {
            title: "Sonstiges",
            paragraphs: [
                "Besichtigungen sind nach Vereinbarung flexibel möglich, auch am Wochenende.",

                "Da es sich um einen Rohbau handelt, empfiehlt sich eine Besichtigung gemeinsam mit Architekt, Gutachter oder Handwerker, um sich einen umfassenden Eindruck von der Bauqualität zu verschaffen.",

                "Der Maklervertrag kommt durch die Inanspruchnahme der Maklertätigkeit zustande. Die Maklercourtage wird mit notariellem Vertragsabschluss fällig. Grunderwerbsteuer und Notarkosten trägt der Käufer."
            ]
        }
    ]
},
    {
        id: "2",

        title: "Denkmalgeschütztes Ensemble in Kochel am See",
        shortTitle: "Einfamilienhaus in Kochel am See",

        location: "82431 Kochel am See",
        price: "595.000 €",

        heroImage: kochel,

        gallery: [kochel],

        facts: [
            { label: "Kaufpreis", value: "595.000 €" },
            { label: "Zimmer", value: "7" },
            { label: "Wohnfläche", value: "160 m²" },
            { label: "Grundstück", value: "618 m²" },
            { label: "Adresse", value: "82431 Kochel am See" }
        ],

        details: [
            { label: "Objektart", value: "Einfamilienhaus (freistehend)" },
            { label: "Etagen", value: "3" },
            { label: "Wohnfläche", value: "160 m²" },
            { label: "Nutzfläche", value: "85 m²" },
            { label: "Grundstück", value: "618 m²" },
            { label: "Zimmer", value: "7" },
            { label: "Badezimmer", value: "1" },
            { label: "Stellplätze", value: "2 Außenstellplätze" },
            { label: "Baujahr", value: "1896" },
            { label: "Ausstattung", value: "Einfache Qualität" },
            { label: "Heizung", value: "Öl-Heizung" },
            { label: "Energieträger", value: "Öl" },
            { label: "Energieausweis", value: "laut Gesetz nicht erforderlich" }
        ],

        sections: [
            {
                title: "Objektbeschreibung",
                paragraphs: [
                    "Der denkmalgeschützte Altbestand besteht aus einem Wohnhaus, einer angebauten Werkstatt (ehemalige Schreinerei) sowie einem Nebengebäude.",

                    "Die Villa wurde um 1896 vom Kochler Schreinermeister Ludwig Fink erbaut. Mauerwerk, Dach und Balken befinden sich in gutem Zustand. Um heutigen Wohnansprüchen zu entsprechen, ist jedoch eine umfassende Sanierung in Abstimmung mit dem Denkmalschutz erforderlich.",

                    "Der Gebäudebestand wurde deshalb mit 0 € bewertet, sodass ausschließlich der Grundstückswert in den Kaufpreis einfließt.",

                    "Gerade in dieser begehrten Lage bietet sich Privatpersonen eine seltene Gelegenheit, ein historisches Anwesen direkt am Kochelsee zu erwerben. Das Ensemble besitzt eine hohe orts- und sozialgeschichtliche Bedeutung."
                ]
            },

            {
                title: "Ausstattung",
                list: [
                    "Wohnfläche Haupthaus ca. 160 m²",
                    "Baujahr ca. 1896",
                    "Erdgeschoss, Obergeschoss und Dachgeschoss",
                    "Ehemalige Werkstatt vielseitig nutzbar (ca. 40 m²)",
                    "Gartenhaus mit ca. 45 m² Wohn- und Nutzfläche",
                    "Öl- und Holzheizung mit Kachelofen",
                    "Zwei Wintergärten",
                    "Überdachter Balkon",
                    "Komplett sanierungsbedürftig",
                    "Denkmalschutz mit attraktiven Abschreibungsmöglichkeiten"
                ]
            },

            {
                title: "Lage",
                paragraphs: [
                    "Das Objekt befindet sich in zentraler Lage von Kochel am See. Restaurants, Cafés, Ärzte, Supermarkt, Kindergarten, Grundschule sowie der Bahnhof sind bequem zu Fuß erreichbar.",

                    "Die Region bietet mit Kochelsee und Walchensee eine einzigartige Naturkulisse und zahlreiche Freizeitmöglichkeiten wie Wandern, Radfahren und Wassersport.",

                    "Kulturelle Highlights wie das Franz Marc Museum, das Kloster Benediktbeuern oder das Freilichtmuseum Glentleiten befinden sich in unmittelbarer Nähe.",

                    "Dank der guten Verkehrsanbindung sind München, Bad Tölz und Garmisch-Partenkirchen schnell erreichbar."
                ]
            },

            {
                title: "Sonstiges",
                paragraphs: [
                    "Das Objekt wird von Frank Immobilien im Alleinauftrag angeboten.",

                    "Das Ensemble eignet sich sowohl als Hauptwohnsitz als auch als außergewöhnliches Ferienhaus in einer der schönsten Regionen Oberbayerns.",

                    "Alle Angaben beruhen auf Informationen des Eigentümers. Irrtümer und Zwischenverkauf vorbehalten. Die Käuferprovision beträgt 2,975 % inkl. MwSt. des notariell beurkundeten Kaufpreises."
                ]
            }
        ]
    },

{
    id: "8",

    title: "Traumhaftes Grundstück für ein Einfamilienhaus in Kochel am See",
    shortTitle: "Grundstück in Kochel am See",

    location: "82431 Kochel am See",
    price: "499.800 €",

    heroImage: grundKochelGross,

    gallery: [grundKochelGross],

    facts: [
        { label: "Kaufpreis", value: "499.800 €" },
        { label: "Fläche", value: "500 m²" },
        { label: "Verfügbarkeit", value: "Sofort" }
    ],

    details: [
        { label: "Vermarktungsart", value: "Kauf" },
        { label: "Erschließung", value: "Erschlossen" },
        { label: "Bebaubar nach", value: "wie Nachbarbebauung" }
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "BAUEN SIE SICH IHREN PERFEKTEN WOHNTRAUM IN SPITZEN LAGE AM KOCHELSEE.",

                "Das ca. 500 m² große Grundstück liegt in zweiter Reihe und ist aufgrund seiner zentralen Lage optimal gelegen.",

                "Der Bauplatz ist sonnig, eben, gut geschnitten und bietet einen wunderbaren Bergblick auf Jochberg, Sonnenspitz und Herzogstand.",

                "Geplant ist der Bau eines Einfamilienhauses.",

                "Wohnraum ist in dieser ausgezeichneten Lage sehr begehrt und stellt für Privatpersonen sowie Bauträger eine seltene Gelegenheit dar, ein Stück Land unmittelbar am Kochelsee zu erwerben."
            ]
        },

        {
            title: "Lage",
            paragraphs: [
                "Die erstklassige Lage und die Nähe zum See ermöglichen eine herausragende Wohn- und Freizeitqualität.",

                "Kochel am See ist nicht nur ein wunderschöner Wohnort, sondern auch ein beliebtes Urlaubsziel.",

                "Die Umgebung bietet zahlreiche Freizeitmöglichkeiten wie Wassersport (Schwimmen, Segeln, Stand-Up-Paddling), Wandern zum Herzogstand und Jochberg sowie kulturelle Angebote wie das Franz Marc Museum und das Freilichtmuseum Glentleiten.",

                "Die Kombination aus attraktiven Wohnmöglichkeiten und traumhafter Umgebung macht Kochel am See zu einem idealen Ort zum Leben oder für einen längeren Aufenthalt."
            ]
        }
    ]
},
{
    id: "3",

    title: "Architektenvilla mit sonnigem Garten und Bergblick",
    shortTitle: "Architektenvilla in Kochel am See",

    location: "82431 Kochel am See",
    price: "1.475.000 €",

    heroImage: architektenVilla,

    gallery: [architektenVilla],

    facts: [
        { label: "Kaufpreis", value: "1.475.000 €" },
        { label: "Adresse", value: "82431 Kochel am See" },
        { label: "Zimmer", value: "8" },
        { label: "Wohnfläche", value: "250 m²" },
        { label: "Grundstück", value: "1.100 m²" }
    ],

    details: [
        { label: "Typ", value: "Villa" },
        { label: "Etagenanzahl", value: "3" },
        { label: "Wohnfläche", value: "250 m²" },
        { label: "Nutzfläche", value: "130 m²" },
        { label: "Grundstück ca.", value: "1.100 m²" },

        { label: "Zimmer", value: "8" },
        { label: "Schlafzimmer", value: "5" },
        { label: "Badezimmer", value: "2" },
        { label: "Garage/Stellplatz", value: "1 Garage" },

        { label: "Sanierung", value: "2026" },
        { label: "Heizungsart", value: "Wärmepumpe" },
        { label: "Energieausweis", value: "liegt zur Besichtigung vor" }
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Das Objekt wird derzeit renoviert und auf den neuesten Stand gebracht. Dadurch besteht die Möglichkeit, noch eigene Wünsche einfließen zu lassen.",

                "Geplant bzw. bereits umgesetzt:",
            ],
            list: [
                "Neue Fenster",
                "Neue Wärmepumpe",
                "Neue Außendämmung",
                "Neue elektrische Rollläden",
                "Einliegerwohnung",
                "Kleine Doppelgarage",
                "Zusätzlicher beheizbarer Raum für Büro oder kleines Gewerbe",
                "Optional zusätzliches Grundstück",
                "Ruhige, gefühlte Alleinlage",
                "Phänomenaler Bergblick",
                "Perfekte Sonneneinstrahlung",
                "In wenigen Minuten zu Fuß zum See",
                "Sackgasse",
                "Außergewöhnliches Objekt in Toplage"
            ]
        },

        {
            title: "Ausstattung",
            list: [
                "Architekten-Villen-Stil mit hoher Raumhöhe",
                "Teilweise runde Türbögen",
                "Großzügige Bauweise",
                "Keller mit guter Höhe",
                "Erstbezug nach Sanierung"
            ]
        },

        {
            title: "Lage",
            paragraphs: [
                "Kochel am See ist eine charmante Gemeinde im bayerischen Voralpenland, bekannt für seine Lage am Kochelsee und die Nähe zu den Bergen.",

                "Die Infrastruktur umfasst Einkaufsmöglichkeiten, Ärzte und Gastronomie. Freizeitmöglichkeiten wie Wassersport, Wandern und Radfahren sind direkt vor der Haustür vorhanden.",

                "Zusätzlich gibt es kulturelle Highlights wie das Franz Marc Museum und die Kristalltherme.",

                "Die Anbindung an das öffentliche Verkehrsnetz ist gut, sodass auch Orte wie Bad Tölz, Murnau und Penzberg schnell erreichbar sind."
            ]
        }
    ]
},

{
    id: "1",

    title: "Einfamilienhaus in Wackersberg mit großem Grundstück",
    shortTitle: "Einfamilienhaus Wackersberg",

    location: "83646 Wackersberg",
    price: "Auf Anfrage",

    heroImage: wackersberg2,

    gallery: [wackersberg2],

    facts: [
        { label: "Kaufpreis", value: "Auf Anfrage" },
        { label: "Adresse", value: "83646 Wackersberg" },
        { label: "Zimmer", value: "5" },
        { label: "Wohnfläche", value: "200 m²" },
        { label: "Grundstück", value: "1.366 m²" }
    ],

    details: [
        { label: "Objektart", value: "Einfamilienhaus (freistehend)" },
        { label: "Etagen", value: "3" },
        { label: "Wohnfläche", value: "200 m²" },
        { label: "Nutzfläche", value: "160 m²" },
        { label: "Grundstück ca.", value: "1.366 m²" },

        { label: "Bezugsfrei ab", value: "sofort" },
        { label: "Zimmer", value: "5" },
        { label: "Schlafzimmer", value: "4" },
        { label: "Badezimmer", value: "2" },
        { label: "Garage/Stellplatz", value: "2 Garagen" },

        { label: "Baujahr", value: "1954" },
        { label: "Sanierung", value: "zuletzt 1974" },
        { label: "Zustand", value: "Renovierungsbedürftig" },
        { label: "Heizungsart", value: "Öl-Heizung" },
        { label: "Energieträger", value: "Öl" },
        { label: "Energieausweis", value: "liegt zur Besichtigung vor" }
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Seltene Gelegenheit! Charmantes Einfamilienhaus mit Esprit in idyllischer Lage.",

                "Das ursprüngliche Haus wurde vermutlich in den 1930er Jahren erbaut und 1954 erweitert und aufgestockt.",

                "Es überzeugt durch eine gemütliche Atmosphäre, helle Räume und eine herrliche Aussichtslage.",

                "Highlight ist das großzügige Wohnzimmer mit ca. 55 m² Wohnfläche inklusive Kachelofen und beeindruckendem Bergblick.",

                "Das Dachgeschoss bietet zusätzlich erhebliches Ausbaupotenzial.",

                "Das Anwesen liegt auf einem großen Grundstück in ruhiger, naturnaher Alleinlage zwischen Bad Tölz und Lenggries.",
            ],

            list: [
                "2 Balkone",
                "Große Terrasse",
                "Alt eingewachsener Garten",
                "Kachelofen",
                "Wohnküche mit Holzbackofen",
                "Speisekammer",
                "Holzbalkendecken",
                "Teilunterkellert",
                "2 Garagen",
                "SAT Empfang"
            ]
        },

        {
            title: "Lage",
            paragraphs: [
                "Die Immobilie liegt im Isartal zwischen Bad Tölz und Lenggries in einer der begehrtesten Wohnlagen der Region.",

                "In unmittelbarer Nähe befinden sich die Isar sowie zahlreiche Wander- und Radwege.",

                "Bad Tölz bietet als Kurstadt eine hervorragende Infrastruktur und eine historische Altstadt.",

                "Lenggries ist bekannt als Outdoor- und Erholungsgebiet mit vielfältigen Sportmöglichkeiten wie Wandern, Skifahren und Rafting.",

                "Die Region bietet eine sehr gute Anbindung Richtung München sowie ein breites Bildungsangebot."
            ]
        }
    ]
},
{
    id: "5",

    title: "Helles Büro / Praxis / Anlage - zentral gelegen",

    shortTitle: "Büro / Praxis in Bad Tölz",

    location: "Bad Tölz",

    price: "329.000 €",

    heroImage: wohnung,

    gallery: [
        wohnung,
    ],

    summary:
        "Helles Büro/Praxis in zentraler Lage mit moderner Ausstattung und guter Anbindung.",

    facts: [
        {
            label: "Kaufpreis",
            value: "329.000 €",
        },
        {
            label: "Nebenkosten",
            value: "700 € / Monat",
        },
        {
            label: "Fläche",
            value: "120 m²",
        },
    ],

    details: [
        {
            label: "Baujahr",
            value: "1934",
        },
        {
            label: "Objektzustand",
            value: "Gepflegt",
        },
        {
            label: "Letzte Modernisierung",
            value: "2022",
        },
        {
            label: "Heizungsart",
            value: "Zentralheizung",
        },
        {
            label: "Denkmalschutz",
            value: "Ja",
        },
        {
            label: "Energieausweis",
            value: "liegt vor",
        },
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Repräsentatives Büro/Praxis in zentraler Lage mit moderner Ausstattung.",
                "4 Zimmer mit offener Küche im Empfangsbereich und WC.",
                "Dachgeschoss mit Aufzug bis ins 1. OG.",
                "Zwei Stellplätze direkt vor dem Haus.",
            ],
        },
        {
            title: "Lage",
            paragraphs: [
                "Bad Tölz ist ein Kurort im bayerischen Oberland mit sehr guter Infrastruktur.",
                "Die Lage bietet kurze Wege zu Bahnhof, Einkaufsmöglichkeiten und Freizeitangeboten.",
            ],
        },
    ],
},
{
    id: "9",

    title: "Traumhaftes Grundstück für ein Einfamilienhaus in Kochel am See",

    shortTitle: "Grundstück in Kochel am See",

    location: "Kochel am See",

    price: "476.000 €",

    heroImage: grundKochelKlein,

    gallery: [
        grundKochelKlein,
    ],

    summary:
        "Baugrundstück in ruhiger zweiter Reihe mit Bergblick in Kochel am See.",

    facts: [
        {
            label: "Kaufpreis",
            value: "476.000 €",
        },
        {
            label: "Fläche",
            value: "476 m²",
        },
        {
            label: "Verfügbarkeit",
            value: "Sofort",
        },
    ],

    details: [
        {
            label: "Vermarktungsart",
            value: "Kauf",
        },
        {
            label: "Erschließung",
            value: "Erschlossen",
        },
        {
            label: "Bebaubar nach",
            value: "Nachbarbebauung",
        },
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Bauen Sie sich Ihren Wohntraum in Spitzenlage am Kochelsee.",
                "Das Grundstück liegt in zweiter Reihe in zentraler Lage.",
                "Sonnig, eben geschnitten und mit Bergblick auf Jochberg, Sonnenspitz und Herzogstand.",
                "Ideal für ein Einfamilienhaus in einer der begehrtesten Regionen.",
            ],
        },
        {
            title: "Lage",
            paragraphs: [
                "Kochel am See bietet eine hohe Lebens- und Freizeitqualität.",
                "Die Region ist bekannt für Natur, Seezugang und vielfältige Outdoor-Aktivitäten wie Wandern, Wassersport und Kulturangebote.",
            ],
        },
    ],
},
{
    id: "6",

    title: "1,5 Zimmer Ferienwohnung mit Berg- und Seeblick in Laax",

    shortTitle: "Ferienwohnung in Laax",

    location: "Laax, Schweiz",

    price: "670.000 €",

    heroImage: laax,

    gallery: [
        laax,
    ],

    summary:
        "Ferienwohnung mit Sauna, Kamin und zwei Terrassen in attraktiver Lage nahe Skipiste und See.",

    facts: [
        {
            label: "Kaufpreis",
            value: "670.000 €",
        },
        {
            label: "Wohnfläche",
            value: "63 m²",
        },
        {
            label: "Zimmer",
            value: "1,5",
        },
        {
            label: "Badezimmer",
            value: "2",
        },
    ],

    details: [
        {
            label: "Typ",
            value: "Erdgeschosswohnung",
        },
        {
            label: "Etage",
            value: "0 von 4",
        },
        {
            label: "Bezugsfrei ab",
            value: "sofort",
        },
        {
            label: "Baujahr",
            value: "1989",
        },
        {
            label: "Objektzustand",
            value: "Gepflegt",
        },
        {
            label: "Ausstattung",
            value: "Gehoben",
        },
        {
            label: "Heizungsart",
            value: "Zentralheizung",
        },
        {
            label: "Stellplätze",
            value: "2 Tiefgaragen (zzgl. Kauf)",
        },
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Pfiffige 1,5 Zimmer Ferienwohnung in Laax, Schweiz.",
                "Direkt an der Skipiste mit Nähe zum Laaxersee (Lag Grond).",
                "Ideal als Ferienwohnung für Sommer und Winter.",
            ],
        },
        {
            title: "Ausstattung",
            list: [
                "2 große Terrassen nach Süden und Westen",
                "Offene Küche mit Miele Geräten",
                "Kamin im Wohnzimmer",
                "Sauna im Appartement",
                "2 Bäder",
                "Einbauschränke und Schreiner-Möbel",
                "2 Tiefgaragenplätze (zzgl.)",
            ],
        },
        {
            title: "Lage",
            paragraphs: [
                "Laax ist eine alpine Region mit hoher Lebensqualität.",
                "Skigebiet, Natur, Seen und Wanderwege direkt vor der Tür.",
                "Sehr gute Anbindung Richtung St. Moritz und Italien.",
            ],
        },
    ],
},
{
    id: "7",

    title: "2 Baugrundstücke mit Bergblick in Kochel am See",

    shortTitle: "Baugrundstücke in Kochel am See",

    location: "Kochel am See",

    price: "975.000 €",

    heroImage: grundKochelZusammen,

    gallery: [
        grundKochelZusammen,
    ],

    summary:
        "Zwei Baugrundstücke mit möglicher Doppelhaus- oder Einfamilienhausbebauung in Kochel am See.",

    facts: [
        {
            label: "Kaufpreis",
            value: "975.000 €",
        },
        {
            label: "Fläche",
            value: "975 m²",
        },
        {
            label: "Verfügbarkeit",
            value: "Sofort",
        },
    ],

    details: [
        {
            label: "Vermarktungsart",
            value: "Kauf",
        },
        {
            label: "Erschließung",
            value: "Erschlossen",
        },
        {
            label: "Bebaubar nach",
            value: "§34 BauGB / Nachbarbebauung",
        },
        {
            label: "Bebauung",
            value: "Doppelhaus oder 2 EFH möglich",
        },
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Bauen Sie sich Ihren Wohntraum in Spitzenlage am Kochelsee.",
                "Das Grundstück bietet ca. 975 m² Fläche in zweiter Reihe.",
                "Genehmigter Vorbescheid für ein Doppelhaus oder zwei Einfamilienhäuser vorhanden.",
                "Sehr gute Voraussetzungen für individuelle Architekturprojekte.",
            ],
        },
        {
            title: "Lage",
            paragraphs: [
                "Kochel am See bietet eine außergewöhnliche Lebens- und Freizeitqualität.",
                "Seen, Berge und vielfältige Freizeitmöglichkeiten befinden sich in unmittelbarer Umgebung.",
            ],
        },
    ],
},
{
    id: "4",
    title: "Grundstück mit Bergblick in Benediktbeuern",
    shortTitle: "Grundstück Benediktbeuern",
    location: "Benediktbeuern",
    price: "1.110.000 €",
    heroImage: benediktbeuern,

    facts: [
        { label: "Fläche", value: "740 m²" }
    ],

    details: [
        { label: "Objektart", value: "Grundstück" },
        { label: "Lage", value: "Ruhige Ortsrandlage" }
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Das Grundstück befindet sich in bester Lage von Benediktbeuern mit sensationellem Blick auf die Benediktenwand.",
                "Es bietet Ihnen vielfältige Möglichkeiten für eine individuelle, natürliche Lebensweise im wunderschönen Alpenvorland.",
                "Denkbar wäre die Nutzung mit einem kleinen Einfamilienhaus, Bungalow, Ferienhaus oder als Kapitalanlage.",
                "Auf dem Grundstück befindet sich ein wunderschön, alt eingewachsener Garten.",
                "Für weitere Informationen bitten wir Sie um Ihre vollständigen Kontaktdaten einschließlich Rufnummer."
            ]
        },
        {
            title: "Lage",
            paragraphs: [
                "Ruhige Ortsrandlage mit sensationellem Bergblick.",
                "Zwei Schwimmbäder, Bahnanschluss und ein Kloster mit Bio-Laden befinden sich in der Nähe.",
                "Zum Kochelsee sind es ca. 8 Autominuten.",
                "Herrliche Natur-Lage im bayerischen Oberland mit guter Anbindung an München."
            ]
        }
    ]
},
{
    id: "11",

    title: "Kaffeemühlen-Villa auf großem Parkgrundstück",
    shortTitle: "Kaffeemühlen-Villa auf 5.237 m²",

    // location: "Auf Anfrage",
    // price: "Preis: Auf Anfrage",

    heroImage: kaffeemuehlenVilla,

    gallery: [kaffeemuehlenVilla],

    summary:
        "Charmante Kaffeemühlen-Villa aus dem Jahr 1926 mit ca. 215 m² Wohnfläche auf einem 5.237 m² großen Parkgrundstück mit sensationellem Bergblick.",

    facts: [
        {
            label: "Kaufpreis",
            value: "Auf Anfrage",
        },
        {
            label: "Wohnfläche",
            value: "215 m²",
        },
        {
            label: "Grundstück",
            value: "5.237 m²",
        },
        {
            label: "Zimmer",
            value: "6",
        },
        {
            label: "Baujahr",
            value: "1926",
        },
    ],

    details: [
        {
            label: "Objektart",
            value: "Villa",
        },
        {
            label: "Wohnfläche",
            value: "ca. 215 m²",
        },
        {
            label: "Nutzfläche",
            value: "ca. 100 m²",
        },
        {
            label: "Grundstück",
            value: "5.237 m²",
        },
        {
            label: "Zimmer",
            value: "6",
        },
        {
            label: "Wohneinheiten",
            value: "3",
        },
        {
            label: "Baujahr",
            value: "1926",
        },
        {
            label: "Zustand",
            value: "Sanierungsbedürftig",
        },
        {
            label: "Denkmalschutz",
            value: "Nein",
        },
        {
            label: "Garage",
            value: "Doppelgarage",
        },
        {
            label: "Dachterrasse",
            value: "Vorhanden",
        },
        {
            label: "Grundstück teilbar",
            value: "Möglich",
        },
    ],

    sections: [
        {
            title: "Objektbeschreibung",
            paragraphs: [
                "Idyllische Kaffeemühlen-Villa aus dem Jahr 1926 auf einem außergewöhnlich großen Parkgrundstück mit 5.237 m².",

                "Die charmante Villa wartet darauf, von einem Liebhaber stilvoll saniert und nach den eigenen Vorstellungen neu gestaltet zu werden. Eine Kernsanierung sowie eine mögliche Erweiterung durch einen passenden Anbau bieten vielfältige Möglichkeiten.",

                "Die praktische und familienfreundliche Raumaufteilung umfasst ca. 215 m² Wohnfläche und sechs Zimmer in drei Wohneinheiten.",

                "Ein besonderes Highlight ist die große Dachterrasse mit einem beeindruckenden Panorama und Blick auf die umliegenden Berge bis zum Karwendel.",

                "Das sonnige Grundstück liegt in leichter Südhanglage und bietet durch seine außergewöhnliche Größe viel Privatsphäre sowie zahlreiche Möglichkeiten für eine individuelle Gestaltung.",

                "Das weitläufige Areal kann bei Bedarf geteilt werden und bietet dadurch zusätzliches Entwicklungspotenzial.",
            ],
        },

        {
            title: "Ausstattung",
            list: [
                "Kaffeemühlen-Villa aus dem Jahr 1926",
                "Ca. 215 m² Wohnfläche",
                "6 Zimmer",
                "3 Wohneinheiten",
                "Ca. 100 m² Nutzfläche",
                "Große Dachterrasse",
                "Sensationeller Berg- und Karwendelblick",
                "5.237 m² großes Parkgrundstück",
                "Sonnige Südhanglage",
                "Eigene Doppelgarage",
                "Großzügige Zufahrt",
                "Kein Denkmalschutz",
                "Erweiterung durch Anbau möglich",
                "Grundstücksteilung grundsätzlich möglich",
            ],
        },

        {
            title: "Lage",
            paragraphs: [
                "Die Immobilie befindet sich in außergewöhnlich ruhiger und naturnaher Lage am Stadtrand.",

                "Trotz der idyllischen Umgebung ist das Stadtzentrum in etwa 15 Gehminuten erreichbar. Damit verbindet das Anwesen viel Privatsphäre und Natur mit einer guten Anbindung an die städtische Infrastruktur.",

                "Die sonnige Südhanglage und der unverbaute Weitblick auf die umliegenden Berge bis zum Karwendel verleihen dem Grundstück einen besonderen Charakter.",
            ],
        },

        {
            title: "Sonstiges",
            paragraphs: [
                "Der Kaufpreis wird auf Anfrage mitgeteilt.",

                "Die Immobilie bietet insbesondere aufgrund der Grundstücksgröße, der möglichen Erweiterung und der möglichen Teilung vielfältige Perspektiven für eine individuelle Nutzung und Entwicklung.",

                "Die Käufercourtage beträgt 2,98 % inklusive Mehrwertsteuer.",
            ],
        },
    ],
},
];

export default properties;